'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderAll = function EditorBorderAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
  );
};
EditorBorderAll = (0, _pure2.default)(EditorBorderAll);
EditorBorderAll.displayName = 'EditorBorderAll';
EditorBorderAll.muiName = 'SvgIcon';

exports.default = EditorBorderAll;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/border-all.js
 ** module id = 1892
 ** module chunks = 0
 **/